import {
	SET_PAGES,
	SET_PAGE,
	CLEAR_PAGES,
	CLEAR_PAGE,
	ADD_PAGE,
	UPDATE_PAGE,
	REMOVE_PAGE,
} from './actionTypes';

export const page = (state = {}, action) => {
	switch (action.type) {
		case SET_PAGE:
			return action.payload;
		case UPDATE_PAGE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_PAGE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_PAGES:
			return action.payload;
		case ADD_PAGE:
			return [...state, action.payload];
		case UPDATE_PAGE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_PAGE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_PAGES:
			return [];
		default:
			return state;
	}
};
